import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFunction = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M2.75 16.5c0 .966.784 1.75 1.75 1.75S6 17.5 6.25 16.5l1.298-6.75M12.25 3.5a1.75 1.75 0 0 0-1.75-1.75c-.966 0-1.5.75-1.75 1.75L7.548 9.75m0 0h3.738a1 1 0 0 1 .764.354L14.5 13M7.548 9.75H4.5m10 3.25 2.75 3.25M14.5 13l2.75-3.25M14.5 13l-2.75 3.25"
	})]
});
const ForwardRef = forwardRef(SvgFunction);
export { ForwardRef as ReactComponent };
